import React, { useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { getData } from "shared/api/services";
import { GET_PROVISION_HISTORY } from "shared";
import { useParams } from "react-router-dom";

dayjs.extend(utc);
dayjs.extend(timezone);

export const useShowProvisionHistory = () => {
  const { idDocument } = useParams();
  const [activeProvisions, setActiveProvisions] = useState(false);
  const [dataProvisions, setDataProvisions] = useState<any[]>([]);
  const [requestCompleted, setRequestCompleted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const convertDataProvisions = (data: any) => {
    setDataProvisions(
      data.map((data: any, index: number) => {
        return {
          id: index,
          documentNumber: data.documentNumber || "N/A",
          provider: data.provider?.name || "N/A",
          provisionValue: data.provisionValue
            ? `$${Number(data.provisionValue).toLocaleString("es-CO")}`
            : "N/A",
          provisionType: data.provisionType || "N/A",
          provisionDate: data.provisionedAt
            ? dayjs(data.provisionedAt).format("DD-MM-YYYY")
            : "N/A",
          sapDocument: data.provisionCode || "N/A",
        };
      }),
    );
  };

  const handleActiveProvisions = (value: boolean) => {
    setActiveProvisions(value);

    if (value && !requestCompleted && !isLoading) {
      callDataProvisionHistory();
    }

    if (!value && dataProvisions.length === 0) {
      setRequestCompleted(false);
    }
  };

  const callDataProvisionHistory = () => {
    setIsLoading(true);
    setHasError(false);
    getData(`${GET_PROVISION_HISTORY}/${idDocument}`)
      ?.then((response: any) => {
        const provisions = Array.isArray(response) ? response : [];
        convertDataProvisions(provisions);
        setRequestCompleted(true);
      })
      .catch((error: any) => {
        console.error("Error fetching provision history:", error);
        setDataProvisions([]);
        setHasError(true);
        setRequestCompleted(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return {
    dataProvisions,
    activeProvisions,
    isLoading,
    hasError,
    handleActiveProvisions,
    callDataProvisionHistory,
    convertDataProvisions,
  };
};
